import { z } from "zod";
import { pageOf, pageQuerySchema } from "../common/pagination.js";
import { timestampSchema, uuidSchema } from "../common/primitives.js";
import { evCommandSourceSchema, evCommandStatusSchema, evCommandTypeSchema, } from "./enums.js";
/**
 * Şarj ünitesine merkezden komutlar (Prompt 19, ADR 0019 §5, `docs/domain/ocpp.md` §4). Kuyruk veritabanındadır
 * (`ev_charger_commands`); API satırı yazar, commit'ten SONRA Redis dürtüsü yayınlar, bağlantıyı tutan OCPP süreci gönderir.
 * Yük OCPP 1.6 isteğidir ve `@station/ev-core` `CENTRAL_SYSTEM_ACTIONS` şemasıyla doğrulanır (bozuk yük 422
 * `VALIDATION_ERROR`, alan yolları `payload.…`). Yanıtta idTag MASKELİDİR (ilk 2 + son 2).
 */
/** Panelden `POST /ev/chargers/{id}/commands` ile verilebilen türler (uzaktan başlatma / güç sınırı bu uçtan verilmez). */
export const EV_OPERATOR_COMMAND_TYPES = [
    "Reset",
    "UnlockConnector",
    "ChangeAvailability",
    "ClearChargingProfile",
    "GetConfiguration",
    "ChangeConfiguration",
    "UpdateFirmware",
    "GetDiagnostics",
];
export const evOperatorCommandTypeSchema = z.enum(EV_OPERATOR_COMMAND_TYPES);
/** Bakım komutları: `ev.maintenance.manage` (adım yükseltme) ister; diğerleri `ev.operate`. */
export const EV_MAINTENANCE_COMMAND_TYPES = [
    "ChangeConfiguration",
    "UpdateFirmware",
    "GetDiagnostics",
];
export function isEvMaintenanceCommand(type) {
    return EV_MAINTENANCE_COMMAND_TYPES.includes(type);
}
export const evCommandProgressSchema = z.object({ at: timestampSchema, status: z.string() });
export const evCommandSchema = z.object({
    id: uuidSchema,
    stationId: uuidSchema,
    chargerId: uuidSchema,
    chargerName: z.string(),
    type: evCommandTypeSchema,
    /** OCPP isteği (idTag maskeli). */
    payload: z.record(z.string(), z.unknown()),
    status: evCommandStatusSchema,
    source: evCommandSourceSchema,
    sessionId: uuidSchema.nullable(),
    idTokenId: uuidSchema.nullable(),
    requestedBy: uuidSchema.nullable(),
    staffId: uuidSchema.nullable(),
    /** Ünitenin OCPP yanıtı (`CALLRESULT` yükü); henüz yoksa null. */
    response: z.unknown().nullable(),
    errorCode: z.string().nullable(),
    errorDescription: z.string().nullable(),
    progress: z.array(evCommandProgressSchema).describe("Yazılım güncelleme / tanılama durum bildirimleri"),
    expiresAt: timestampSchema,
    sentAt: timestampSchema.nullable(),
    finishedAt: timestampSchema.nullable(),
    createdAt: timestampSchema,
});
export const evCommandPageSchema = pageOf(evCommandSchema);
export const listEvCommandsQuerySchema = pageQuerySchema.extend({
    status: evCommandStatusSchema.optional(),
    type: evCommandTypeSchema.optional(),
});
export const createEvCommandSchema = z.object({
    type: evOperatorCommandTypeSchema,
    payload: z
        .record(z.string(), z.unknown())
        .default({})
        .describe("OCPP 1.6 isteği (ör. Reset → { type: 'Soft' }, UnlockConnector → { connectorId: 1 })"),
});
// ── Uzaktan başlatma (panel) ─────────────────────────────────────────────────
export const evRemoteStartRequestSchema = z.object({
    connectorNo: z.number().int().min(1).max(20),
});
export const evRemoteStartResultSchema = z.object({
    command: evCommandSchema,
    /** Tek kullanımlık belirteç (`ev_id_tokens`, amaç `WEB`); idTag DÖNMEZ (komut yükünde maskeli). */
    tokenId: uuidSchema,
    expiresAt: timestampSchema.describe("Belirtecin son kullanım anı"),
});
//# sourceMappingURL=commands.js.map